import { createContext } from 'react';

export const ColorContext = createContext<any>('mintcream');